import React from "react";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import PercentageChart from "./PercentageChart";
import { addCommas } from "src/storage/helpers";
import styled from "styled-components";

const PercentageChartContainer = styled.div`
  flex: 0 0 auto;

  @media (max-width: 1260px) {
    display: none;
  }
`;

const HeroCharts = ({ activeFilter, statsForActiveFilter }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cornerRadius: 2,
    indexAxis: "y",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          label: (context) => {
            return `${addCommas(context.raw)} ${activeFilter}`;
          },
        },
      },
      // Custom plugin for overlaying text
      datalabels: {
        display: true,
        color: "white",
        anchor: "start",
        align: "end",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: function (_, context) {
          // Show the label (company name) instead of the value
          return context.chart.data.labels[context.dataIndex];
        },
      },
    },
    scales: {
      y: {
        title: {
          display: false,
        },
        ticks: {
          display: false, // Hide y-axis labels
        },
      },
      x: {
        suggestedMax: 50,
        title: {
          display: true,
        },
        ticks: {},
      },
    },
  };

  const statsZeroRemoved = statsForActiveFilter.filter(
    (stat) => stat.value !== 0,
  );

  const chartData = {
    labels: statsZeroRemoved.map((val) => val?.name),
    datasets: [
      {
        data: statsZeroRemoved.map((val) => val?.value),
        borderColor: "black",
        borderRadius: 4,
        borderWidth: 1,
        barPercentage: 0.9,
        backgroundColor: statsZeroRemoved.map((v) => v?.color),
      },
    ],
  };

  const recommendedMinHeight = Math.max(statsZeroRemoved.length * 32 + 50, 290);

  return (
    <div
      style={{
        width: "100%",
        minHeight: 200,
        borderRadius: 12,
      }}
    >
      <div
        style={{
          width: "100%",
          borderBottom: "1px solid #eeeeee",
          padding: 12,
        }}
      >
        <p style={{ fontSize: 14, fontWeight: 600, marginLeft: 6 }}>
          {activeFilter}
        </p>
      </div>
      <div
        style={{
          width: "100%",
          minHeight: 180,
          padding: 16,
          display: "flex",
          flexDirection: "row",
          overflowY: "auto",
          alignItems: "flex-start",
          justifyContent: "stretch",
        }}
      >
        <div
          style={{
            flex: "1 1 0%",
            minWidth: 0,

            minHeight: recommendedMinHeight,
          }}
        >
          <Bar data={chartData} options={options} plugins={[ChartDataLabels]} />
        </div>
        <PercentageChartContainer>
          <PercentageChart
            activeFilter={activeFilter}
            statsForActiveFilter={statsZeroRemoved}
          />
        </PercentageChartContainer>
      </div>
    </div>
  );
};

export default HeroCharts;
